import { Address } from "../../models/address.model";
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { GoogleMapsService } from '../../services/google-maps/google-maps.service';

@Component({
    selector: 'app-predictive-address-search',
    templateUrl: './predictive-address-search.component.html',
    styleUrls: ['./predictive-address-search.component.scss'],
    standalone: false
})
export class PredictiveAddressSearchComponent implements OnInit {
  AddressForm: FormGroup = new FormGroup({
    address: new FormControl(''),
    aptSuitUnit: new FormControl(''),
    city: new FormControl(''),
    province: new FormControl(''),
    postalCode: new FormControl('')
  });
  @ViewChild('aptSuitUnitInput') aptSuitUnitInput: ElementRef;
  hideFields: boolean = true;
  autocomplete: google.maps.places.Autocomplete;
  @Input() formGroupName!: string;
  @ViewChild('shipAddressInput') shipAddressInput: ElementRef;
  @Input() isPreviewMode: boolean;
  @Input() disabled: boolean;
  loaded: boolean = false;
  isReadOnlyMode = false;
  @Output() addressChanged = new EventEmitter<Address>;

  constructor(public rootFormGroup: FormGroupDirective, private cdr: ChangeDetectorRef,
    @Inject('GoogleMapsService') public mapService: GoogleMapsService) { }

  ngOnInit(): void {
    this.mapService.loadGoogleMapsAPI();
    if (this.formGroupName && this.rootFormGroup.control)
      this.AddressForm = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
     
    if ((this.AddressForm.get('address')!.value).length > 0){
        this.hideFields = false;
    }
    this.AddressForm.get('aptSuitUnit')!.valueChanges.subscribe(() => {
      const newAddr = new Address(
        '',
        this.AddressForm.get('postalCode')!.value, 
        this.AddressForm.get('address')!.value,
        this.AddressForm.get('aptSuitUnit')!.value,
        '', 
        this.AddressForm.get('city')!.value,
        this.AddressForm.get('province')!.value,
        'Canada');

      this.addressChanged.emit(newAddr);
    });
  }

  keyPress(event: KeyboardEvent) {
    this.initAutocomplete();
  }

  setDisabledMode(on: boolean) {
    if (on) {
      this.isPreviewMode = false;
      this.isReadOnlyMode = true; 
    } else {
      this.isReadOnlyMode = false; 
    }
  }

  valid(): boolean {
    return this.AddressForm.valid;
  }

  setAddress(addr: Address) {
    this.AddressForm.controls["address"].setValue(addr.AddressLine);
    this.AddressForm.controls["aptSuitUnit"].setValue(addr.AptSuiteUnit);
    this.AddressForm.controls["city"].setValue(addr.CityTown);
    this.AddressForm.controls["province"].setValue(addr.Province);
    this.AddressForm.controls["postalCode"].setValue(addr.PostalCode);
  }

  clearFormFields(obj: string | null) {  
    this.AddressForm.controls['aptSuitUnit'].reset();
    this.AddressForm.controls['city'].reset();
    this.AddressForm.controls['province'].reset();
    this.AddressForm.controls['postalCode'].reset();     
    if(obj == null) {
      this.hideFields = true;
    }
    else{
      this.hideFields = false;
    }
  }
  
  initAutocomplete() {
    const addressInput: HTMLInputElement = this.shipAddressInput.nativeElement;
    this.autocomplete = new google.maps.places.Autocomplete(addressInput, {
      componentRestrictions: { country: ["ca"] },
      fields: ["address_components", "geometry"],
      types: ["address"],
    });
  
    this.autocomplete.addListener("place_changed", () => this.fillInAddress());
  }

  fillInAddress() {
    // Get the place details from the autocomplete object.
    const place = this.autocomplete.getPlace();
    let address1 = "";
    let postcode = "";
    let city = "";
    let province = "";  
    let aptSuit = "";
    this.hideFields = false;
    this.cdr.detectChanges()
    if (place) {
      for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
        const componentType = component.types[0];

        switch (componentType) {
          case "street_number": {
            address1 = `${component.long_name} ${address1}`;
            break;
          }
          
          case "subpremise": {
            aptSuit = component.long_name;
            break;
          }

          case "route": {
            address1 += component.short_name;
            break;
          }

          case "postal_code":
            if (postcode) {
              postcode = `${component.long_name}${postcode}`;
            } else {
              postcode = component.long_name;
            }
            break;

            case "postal_code_suffix": {
              postcode = `${postcode}-${component.long_name}`;
              break;
            }

            case "postal_code_prefix": {
              postcode = `${component.long_name}`;
              break;
            }

          case "sublocality_level_1": {
            if (city) {
              city = `${component.long_name}, ${city}`;
            } else {
              city = component.long_name;
            }
            break;
          }
          case "locality":
            if (!city) {
              city = component.long_name;
            }
            break;

          case "administrative_area_level_1": {
            province = component.short_name;
            break;
          }
        }
      }
    }

    this.AddressForm.patchValue({
      address: address1,
      postalCode: postcode,
      city: city,
      province: province,   
      aptSuitUnit: aptSuit
    });
    if (this.aptSuitUnitInput) {
      this.aptSuitUnitInput.nativeElement.focus();
    }
    const newAddr = new Address('', postcode, address1, aptSuit, '', city, province, 'Canada');
    this.addressChanged.emit(newAddr);
  } 
}
